const currency=value=>Number(value||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});
export default function MonthlyGoalSummary({month,goal,sold,loaded,error,isConsultant=false}){
  return <section aria-label={isConsultant?"Meta mensal individual":"Meta mensal da loja"}
    style={{margin:"12px 0",padding:14,border:"1px solid #DDD7CC",borderRadius:10,background:"#fff"}}>
    <strong>{isConsultant?"Meta mensal individual":"Meta mensal da loja"} · {month}</strong>
    {error?<div role="alert">{error}</div>:!loaded?<div role="status">Carregando vendas do mês…</div>:
      <div style={{display:"flex",gap:20,flexWrap:"wrap",marginTop:8}}>
        <span>Vendido: <b>{currency(sold)}</b></span>
        <span>Meta: <b>{currency(goal)}</b></span>
        <span>Falta: <b>{currency(Math.max(0,goal-sold))}</b></span>
        <span>Atingido: <b>{goal>0?(sold/goal*100).toLocaleString("pt-BR",{maximumFractionDigits:1}):"0"}%</b></span>
      </div>}
  </section>;
}
